import React, { useEffect } from 'react'
import PDCMarkdown from 'pdc-markdown'
import { Dialog } from 'functional-foundations'
import { Typography } from 'foundations-library/components'

/**
 * Props for the ShowInPopup component.
 */
export interface ShowInPopupProps {
    isOpen?: boolean
    onClose?(): void
    popupContent?: JSX.Element | string
    scrollDestination?: string
    styleOverrides?: Record<string, any>
}

/**
 *
 */
const ShowInPopup = ({
    isOpen = false,
    onClose,
    popupContent = '',
    scrollDestination = '',
    styleOverrides = {}
} : ShowInPopupProps): JSX.Element => {
    useEffect(() => {
        if (!isOpen && !scrollDestination) return

        let cancelled = false
        let rafId = 0

        const scrollToTarget = () => {
            if (cancelled) return

            if (scrollDestination) {
                const el = document.getElementById(scrollDestination)
                if (el) {
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    })
                    return
                }
            }

            window.scrollTo({ top: 0 })
        }

        rafId = window.requestAnimationFrame(() => {
            rafId = window.requestAnimationFrame(scrollToTarget)
        })

        return () => {
            cancelled = true
            window.cancelAnimationFrame(rafId)
        }
    }, [isOpen, scrollDestination])

    const renderContent = () => {
        if (typeof popupContent === 'string') {
            return <PDCMarkdown styleOverrides={styleOverrides}>{popupContent}</PDCMarkdown>
        }
        return popupContent
    }

    const content = !popupContent
        ? <Typography variant='subtitle1'>Not found</Typography>
        : (
            <div style={{ padding: '40px 10%' }} data-testid='markdown-wrapper'>
                {renderContent()}
            </div>
        )

    return (
        <Dialog isOpen={isOpen} onClose={onClose} aria-labelledby='article-dialog' size='90%' height={'90%'} data-testid='show-in-popup'>
            {isOpen ? content : null}
        </Dialog>
    )
}

export default ShowInPopup
